import { createContext, useEffect } from "react";
import { translationStore } from "./store";
import { observer } from "mobx-react";

export const TranslationContext = createContext(translationStore);

export const TranslationProvider = observer(function TranslationProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  useEffect(() => {
    translationStore.hydratePersistedLocale();
  }, []);

  return (
    <TranslationContext.Provider value={translationStore}>{children}</TranslationContext.Provider>
  );
});
